<template>
  <arrows-icon
    class="fi-arrow-icon__sized fi-arrow-icon"
    data-id="fi-arrow-icon"
  />
</template>

<script setup lang="ts">
import ArrowsIcon from 'svg-icons/arrows.svg';
</script>

<style src="./arrow-icon" />
